<template>
  <div id="app">
    <v-app id="inspire">
      <v-card v-model="show" color="#FFFF99">
        <v-card-title>
          <v-icon large left>mdi-excavator</v-icon>
          <h6>Obra - Listado de Recepciones sin Documentación</h6>
        </v-card-title>
        <v-card-text class="pt-2">
          <v-row dense>
            <v-col cols="12" sm="12" md="4">
                 <v-text-field label="Filtro por Referencia" dense v-model="filtroreferencia">
              </v-text-field>
              </v-col>
              <v-col cols="6" sm="6" md="4">
              <v-text-field
                label="Filtro por Código Recepción"
                dense
                v-model="filtrocodgral"
              >
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="4">
              <v-text-field
                label="Filtro por Responsable"
                dense
                v-model="filtroresponsable"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" sm="6" md="2">
              <v-text-field
                label="Filtro por remito"
                dense
                v-model="filtroremito"
              >
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="2">
              <v-text-field
                label="Filtro por Descripción"
                dense
                v-model="filtrodescrip"
              >
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="2">
              <v-text-field
                label="Filtro por fecha"
                dense
                v-model="filtrofecha"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="space-around">
            <v-btn
              tile
              color="success"
              @click="
                cargarListado(
                  filtroreferencia,
                  filtrocodgral,
                  filtrodescrip,
                  filtrofecha,
                  filtroresponsable,
                  filtroremito
                )
              "
            >
              <v-icon left> mdi-magnify </v-icon>
              Buscar
            </v-btn>
          </v-row>
        </v-card-text>
      </v-card>
      <v-data-table
        dense
        :headers="headers"
        :items="listadoremitos"
        locale="es-ar"
        class="elevation-1"
        :items-per-page="100"
        :footer-props="{
          itemsPerPageText: 'Remitos por página',
        }"
      >
      </v-data-table>
      
    </v-app>
  </div>
</template>

<script>
import axios from "../../../src/axios-auth";
export default {
  data: (vm) => ({
    filtroreferencia: "",
    filtrocodgral: "",
    filtroresponsable: "",
    filtroremito: "",
    filtrodescrip: "",
    filtrofecha: "",
    listadoremitos:[],
    headers: [
        {
          text: 'Código',
          align: 'start',
          sortable: false,
          value: 'codgral',
        },
        { text: 'Referencia', value: 'referencia', sortable: false },
        { text: 'Fecha', value: 'fecha', sortable: false },
        { text: 'Proveedor', value: 'proveedor', sortable: false },
        { text: 'Cantidad', value: 'cantidad', sortable: false },
        { text: 'Unidad', value: 'unidad', sortable: false },
        { text: 'Descripción', value: 'descrip', sortable: false },
        { text: 'Remito', value: 'remito', sortable: false },
        { text: 'Lugar', value: 'lugar', sortable: false },
        { text: 'Firma', value: 'responsable', sortable: false },
      ],
  }),

  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },

  methods: {
    
    cargarListado() {
      const referencia =  this.filtroreferencia
      const responsable = this.filtroresponsable
      const remito = this.filtroremito
      const codgral = this.filtrocodgral
      const fecha = this.filtrofecha
      const descrip = this.filtrodescrip
      let self = this;
      axios
        .get("/Obras/ListadoRecepMatSinDoc?", {
          params: {
            referencia: referencia,
            codgral: codgral,
            remito: remito,
            responsable: responsable,
            fecha: fecha,
            descrip: descrip,
            
          }
        })
        .then(response => {
          self.listadoremitos = response.data;
        })
        .catch(error => {
          self.listadoremitos = [];
          console.log(error);
        });
        
    },

  },
};
</script>